export class Text {
    
    public Title: string;
    
    public Body: string;
}